/**
 * Generato automaticamente.
 * framework-cfg-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { TipoMittenteDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Ottiene l'elenco dei tipi di mittente ordinati per codice
 * @summary Elenco Tipi Mittente
 */
export const getTipiMittente = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<TipoMittenteDTO[]>(
    { url: `/framework-cfg-procedimenti/tipi-mittente`, method: 'get', signal },
    options,
  );
};

export const getGetTipiMittenteQueryKey = () =>
  [`/framework-cfg-procedimenti/tipi-mittente`] as const;

export const getGetTipiMittenteQueryOptions = <
  TData = Awaited<ReturnType<typeof getTipiMittente>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiMittente>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getTipiMittente>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTipiMittenteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTipiMittente>>> = ({
    signal,
  }) => getTipiMittente(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetTipiMittenteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTipiMittente>>
>;
export type GetTipiMittenteQueryError = ErrorType<unknown>;

/**
 * @summary Elenco Tipi Mittente
 */
export const useGetTipiMittente = <
  TData = Awaited<ReturnType<typeof getTipiMittente>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTipiMittente>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetTipiMittenteQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
